import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServiceHighlights from './components/ServiceHighlights';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';
import Psychiatry from './/Management/psychiatry';
import Telehealth from './/Management/telehealth';
import PrivacyPolicy from './components/Privacy';
import Form from './/forms/Form'
import Box from '@mui/material/Box';
import ScrollToTop from './ScrollToTop';
import QbTest from './Management/qbtest'
import Creyos from './Management/creyos';
import Esketamine from './Management/esketamine';
import Suboxone from './Management/suboxone';
import ScheduleAppointment from './components/ScheduleAppointment';
import { Analytics } from '@vercel/analytics/react';
import GoogleTag from './components/GoogleTag';
import TMS from './Management/tms';
import Insurance from './components/Insurance';
import FAQPage from './components/FAQPage';

function App() {
  return (
    <Router>
      <GoogleTag />
      <ScrollToTop />
      <div className="App">
        <Header />
        <Box maxWidth="100vw" sx={{ pt: 8 }}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <HeroSection />
                  <Box sx={{ backgroundColor: 'white' }}>
                    <ServiceHighlights />
                    <WhyChooseUs />
                    <Box sx={{ backgroundColor: '#f0f4e8' }}>
                      <Contact />
                    </Box>
                  </Box>
                </>
              }
            />
            <Route path="/psychiatry" element={<Psychiatry />} />
            <Route path="/telehealth" element={<Telehealth />} />
            <Route path="/qbtest" element={<QbTest />} />
            <Route path="/creyos" element={<Creyos />} />
            <Route path="/esketamine" element={<Esketamine />} />
            <Route path="/suboxone" element={<Suboxone />} />
            <Route path="/tms" element={<TMS />} />
            <Route path="/online-forms" element={<Form />} />
            <Route path='/about-us' element={<About />} />
            <Route path='/privacy' element={<PrivacyPolicy />} />
            <Route path='/schedule-appointment' element={<ScheduleAppointment />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/faq" element={<FAQPage />} />
          </Routes>
        </Box>
        <Footer />
      </div>
      <Analytics />
    </Router>
  );
}

export default App;
